import React, { ReactElement } from "react";
import dynamic from "next/dynamic";
import MainBanner from "@components/iforklift/mainBanner/mainBanner";
import { GetServerSideProps } from "next";

import IForkLiftWrapper from "@components/layouts/iForkLiftWrapper";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";

const WhyUs = dynamic(() => import("@components/iforklift/whyUs"));
const OffersList = dynamic(() => import("@components/shared/offersList"));
export default function Home(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <IForkLiftWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <WhyUs />
        </IForkLiftWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
